import React from 'react';
import './TrainingLoader.css';

const TrainingLoader = () => {
  return (
    <div className="training-loader">
      <div className="loader-animation">
        <div className="icon book"></div>
        <div className="icon chart"></div>
        <div className="icon diploma"></div>
      </div>
      <p>Loading Corporate Training Content...</p>
    </div>
  );
};

export default TrainingLoader;
